import { render, staticRenderFns } from "./defaultCompanyHeader.vue?vue&type=template&id=6004c328&"
import script from "./defaultCompanyHeader.vue?vue&type=script&lang=js&"
export * from "./defaultCompanyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports